<template>
  <div class="Society">
    <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
    <div class="Society_box" v-if="SocietyData ">
      <div
        class="Society_box_content"
        v-for="(item, index) in SocietyData.slice(0, 3)"
        :key="index"
        @click="toArticles(item.id)"
        :style="`--background:${item.sdgColor?item.sdgColor:'rgba(6,108,172,1)'}`"
      >
        <div class="Society_img_box">
          <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />

          <div class="title" :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="Society_text">
          <div
            :class="[language == 'zh'?'zhFamily':'enfamily']"
            class="Society_text_content"
            v-html="$options.filters.formatTime(item.content,language, 70, 150)"
          ></div>
          <!-- <div class="more">查看更多></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["SocietyData"],
  computed: {
    Module_title: function() {
      return {
        name: "Society",
        more: true,
        ehTitle: this.$t("Nav.Menu.Society"),
        zhTitle: this.$t("Nav.Menu.Society")
      };
    }
  },
  data() {
    return {
      // Module_title: { name: "Society", more: true,ehTitle:'SDGs and Society', zhTitle:'SDGs and Society'}
    };
  },
  filters: {
    formatTime: function(value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      msg = msg.replace(/\s+/g, " "); //去掉npsp
      // return msg.slice(0, zhNum).concat("......");
      if (language == "zh") {
        return msg.slice(0, zhNum).concat("......");
      } else {
        return msg.slice(0, enNum).concat("...");
      }
    }
  },
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    }
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue")
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .zhFamilytitle {
    font-family: $zhFamily;
    font-size: 30px;
    line-height: 32px;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
    font-size: 30px;
    line-height: 32px;
  }
  .zhFamily {
    font-family: $zhFamily;
    font-size: 16px;
  }
  .enfamily {
    font-family: $enFamily;
    font-size: 16px;
  }
  .Society {
    width: 1200px;
    margin: 60px auto 0;
    .Society_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }
  .Society_box {
    display: flex;
    flex-direction: row;
    // height: 600px;
    .Society_box_content:last-child {
      margin-right: 0px;
    }
    .Society_box_content:first-child {
      margin-left: 0px;
    }
    .Society_box_content {
      cursor: pointer;
      margin: 0px 10px 20px;
      // background: #ccc;
      width: 100%;
      height: 100%;
      &:hover .Society_text {
        // background: #00689d;
        background-color: var(--background);
        color: #fff;
        // transition: 0.8s ease;
      }
      &:hover img {
        transition: 0.8s ease;
        transform: scale(1.2, 1.2);
      }
      &:hover .Society_text .more {
        color: #fff;
        transition: 0.8s ease;
      }
      .Society_img_box {
        position: relative;
        width: 386px;
        height: 426px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
          transition: 0.8s ease;
        }

        .title {
          width: 100%;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.1)
          );
          // width: 100%;
          padding: 20px;
          // height: 80px;
          position: absolute;
          bottom: 0;
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          // margin-bottom: 15px;
        }
      }
      .Society_text {
        width: 100%;
        height: 164px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        // border-radius: 4px;
        background: #f8f8f8;
        color: #333333;

        .Society_text_content {
          word-wrap: break-word;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 3;
          overflow: hidden;
          word-break: break-word;
          letter-spacing: 0px;
          padding: 20px;
          line-height: 26px;
          font-size: 16px;

          // font-weight: 600;
        }
        .more {
          padding-left: 20px;
          // width: 80px;
          margin-top: 14px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #006eff;
          line-height: 22px;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .zhFamilytitle {
    font-family: $zhFamily;
    font-size: 30px;
    line-height: 32px;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
    font-size: 30px;
    line-height: 32px;
  }
  .zhFamily {
    font-family: $zhFamily;
    font-size: 16px;
  }
  .enfamily {
    font-family: $enFamily;
    font-size: 16px;
  }
  .Society {
    width: 1200px;
    margin: 60px auto 0;
    .Society_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }
  .Society_box {
    display: flex;
    flex-direction: row;
    // height: 600px;
    .Society_box_content:last-child {
      margin-right: 0px;
    }
    .Society_box_content:first-child {
      margin-left: 0px;
    }
    .Society_box_content {
      cursor: pointer;
      margin: 0px 10px 20px;
      // background: #ccc;
      width: 100%;
      height: 100%;
      &:hover .Society_text {
        // background: #00689d;
        background-color: var(--background);
        color: #fff;
        // transition: 0.8s ease;
      }
      &:hover img {
        transition: 0.8s ease;
        transform: scale(1.2, 1.2);
      }
      &:hover .Society_text .more {
        color: #fff;
        transition: 0.8s ease;
      }
      .Society_img_box {
        position: relative;
        width: 386px;
        height: 426px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
          transition: 0.8s ease;
        }

        .title {
          width: 100%;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.1)
          );
          // width: 100%;
          padding: 20px;
          // height: 80px;
          position: absolute;
          bottom: 0;
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          // margin-bottom: 15px;
        }
      }
      .Society_text {
        width: 100%;
        height: 164px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        // border-radius: 4px;
        background: #f8f8f8;
        color: #333333;

        .Society_text_content {
          word-wrap: break-word;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 3;
          overflow: hidden;
          word-break: break-word;
          letter-spacing: 0px;
          padding: 20px;
          line-height: 26px;
          font-size: 16px;

          // font-weight: 600;
        }
        .more {
          padding-left: 20px;
          // width: 80px;
          margin-top: 14px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #006eff;
          line-height: 22px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .Society {
    // width: 100%;
    padding: 10px;
    .Society_title {
      display: inline-block;
      color: #fff;
      background: #439f38;
    }
  }
  .Society_box {
    display: flex;
    flex-direction: column;
    // height: 600px;
    .Society_box_content:last-child {
      margin-right: 0px;
    }
    .Society_box_content:first-child {
      margin-left: 0px;
    }
    .Society_box_content {
      margin-bottom: 14px;

      cursor: pointer;
      width: 100%;
      height: 100%;
      &:hover .Society_text {
        // background: #00689d;
        background-color: var(--background);
        color: #fff;
        // transition: 0.8s ease;
      }
      &:hover img {
        transition: 0.8s ease;
        transform: scale(1.2, 1.2);
      }
      &:hover .Society_text .more {
        color: #fff;
        transition: 0.8s ease;
      }
      .Society_img_box {
        position: relative;
        width: 100%;
        height: 220px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
          transition: 0.8s ease;
        }

        .title {
          width: 100%;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.1)
          );
          // width: 100%;
          padding: 10px;
          // height: 80px;
          position: absolute;
          bottom: 0;
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          // margin-bottom: 15px;
        }
      }
      .Society_text {
        width: 100%;
        // height: 134px;
        padding: 10px 10px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        // border-radius: 4px;
        background: #f8f8f8;
        color: #333333;

        .Society_text_content {
          word-wrap: break-word;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          letter-spacing: 0px;
          padding: 10px 0;
          line-height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          // font-weight: 600;
        }
        .more {
          padding-left: 20px;
          // width: 80px;
          margin-top: 14px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #006eff;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
